import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialLinks from "./SocialLinks";
import { useTranslation } from "../i18n";

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <Container fluid className="footer">
      <Row>
        <Col xs={12} md={4} className="footer-copywright">
          <h3>{t("footer.designedBy")}</h3>
        </Col>
        <Col xs={12} md={4} className="footer-copywright">
          <h3>
            {t("footer.copyright")} {year} YP
          </h3>
        </Col>
        <Col xs={12} md={4} className="footer-body">
          <ul className="footer-icons">
            <SocialLinks linkStyle={{ color: "white" }} iconClassName="" />
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
